import { useAdminGetUpcomingRoomReservationSummaryLazyQuery } from '@exam-center/graphql';
import { useCallback } from 'react';

export interface RoomReservationSummary {
  examCenterCode: string;
  eventCount: number;
  startDate: Date;
  endDate: Date;
}

export interface GetRoomReservationSummaryResult {
  hasReservations: boolean;
  reservations: RoomReservationSummary[];
}

export function useGetRoomReservationSummary() {
  const [fetchQuery] = useAdminGetUpcomingRoomReservationSummaryLazyQuery();

  const checkReservations = useCallback(
    async (
      roomId: string,
      examCenterCodes?: string[] | null,
    ): Promise<GetRoomReservationSummaryResult> => {
      const result = await fetchQuery({
        variables: {
          getUpcomingRoomReservationSummaryInput: {
            roomId,
            ...(examCenterCodes ? { examCenterCodes } : {}),
          },
        },
      });
      if (result.error) {
        throw result.error;
      }

      if (!result.data) {
        throw new Error('No data returned from adminGetUpcomingRoomReservationSummary query');
      }
      const summaries =
        result.data.ecAdminGetUpcomingRoomReservationSummary.roomReservationSummaries;
      const reservations = summaries.map((s) => ({
        examCenterCode: s.examCenterCode,
        eventCount: s.reservationCount,
        startDate: s.startedAt,
        endDate: s.endedAt,
      }));

      return {
        hasReservations: reservations.length > 0,
        reservations,
      };
    },
    [fetchQuery],
  );

  return { checkReservations };
}
